import React, { useState } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import { SafeAreaView } from 'react-native-safe-area-context';
import CustomDropDown from '../../../../components/CustomDropDown/CustomDropdown';
import { useTranslation } from 'react-i18next';

const ExcelColumnsComponent = ({ dropdowns, columnData, onValueChange }) => {
    const [selectedValue, setSelectedValue] = useState({});
    const { t } = useTranslation();
    const handleValueChange = (columnName, value) => {
        setSelectedValue(prevState => ({ ...prevState, [columnName]: value }));
        onValueChange(columnName, value); 
    };
    return (
            <ScrollView>
                {/* <ScrollView horizontal={true} showsHorizontalScrollIndicator={true}> */}
                    <View style={styles.container}>
                        {/* Header Row */}
                        <View style={styles.row}>
                            <SafeAreaView style={[styles.columnName, { backgroundColor: '#dcdcdc' }]}>
                                <CustomLabel
                                    value={t('common:columnName').toUpperCase()}
                                    type='MAJOR' />
                            </SafeAreaView>
                            <SafeAreaView style={[styles.columnName, { backgroundColor: '#dcdcdc' }]}>
                                <CustomLabel
                                    value={t('common:description').toUpperCase()}
                                    type='MAJOR' />
                            </SafeAreaView>
                            <SafeAreaView style={[styles.columnName, { backgroundColor: '#dcdcdc' }]}>
                                <CustomLabel
                                    value={t('common:dataType').toUpperCase()}
                                    type='MAJOR' />
                            </SafeAreaView>
                            <SafeAreaView style={[styles.columnName, { backgroundColor: '#dcdcdc' }]}>
                                <CustomLabel
                                    value={t('common:maxLength').toUpperCase()}
                                    type='MAJOR' />
                            </SafeAreaView>
                        </View>
                        {/* Data Rows */}
                        {columnData.data.map(column => {
                            const columnDetail = t(`databaseTableMappings:${column.COLUMN_NAME}`, { returnObjects: true }) || { displayName: column.COLUMN_NAME, description: '' };
                            const maxLength = (column.CHARACTER_MAXIMUM_LENGTH > 0) ? column.CHARACTER_MAXIMUM_LENGTH : t('common:noMaxLength');
                            const dataType = t(`databaseTableMappings:${column.DATA_TYPE.toLowerCase()}`, { returnObjects: true }) || { displayName: column.DATA_TYPE };
                            return (
                                <View key={column.COLUMN_NAME} style={styles.row}>
                                    <SafeAreaView style={[styles.columnName, { backgroundColor: '#f2f2f2' }]}>
                                        <CustomLabel
                                            value={columnDetail.displayName.toUpperCase()}
                                            type='MAJOR' />
                                    </SafeAreaView>
                                    {dropdowns?.hasOwnProperty(column.COLUMN_NAME) ? (
                                        <SafeAreaView style={[styles.columnName, styles.centered]}>
                                            <CustomDropDown
                                                defValue={selectedValue[column.COLUMN_NAME]}
                                                options={dropdowns[column.COLUMN_NAME].map(option => ({
                                                    value: option.ID,
                                                    label: option.Description,
                                                    key: option.ID
                                                }))}
                                                setValue={(value) => handleValueChange(column.COLUMN_NAME, value)}
                                                multiple={false}
                                                disabled={false}
                                                type='MASS_UPLOAD'
                                            />
                                        </SafeAreaView>
                                    ) : (
                                        <SafeAreaView style={styles.columnName}>
                                            <CustomLabel
                                                value={columnDetail.description}
                                                type='MAJOR' />
                                        </SafeAreaView>
                                    )}
                                    <SafeAreaView style={[styles.columnName, { backgroundColor: '#f2f2f2' }]}>
                                        <CustomLabel
                                            value={dataType.displayName}
                                            type='MAJOR' />
                                    </SafeAreaView>
                                    <SafeAreaView style={styles.columnName}>
                                        <CustomLabel
                                            value={`${t('common:maxLength')}: ${maxLength}`}
                                            type='MAJOR' />
                                    </SafeAreaView>
                                </View>
                            );
                        })}
                    </View>
                {/* </ScrollView> */}
            </ScrollView>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        width: '100%'
    },
    row: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#ddd',
        width: '100%'
    },
    columnName: {
        width: '25%',
        flexWrap: 'wrap',
        padding: 8,
        fontSize: 18,
    },
    halfWidth: {
        width: '50%'
    },
    centered: {
        justifyContent: 'center',
        alignItems: 'center'
    }
});

export default ExcelColumnsComponent;